const COLLECTION_ITEM_TYPES = {
  CHILD_COLLECTION: 'CHILD_COLLECTION',
  CHILD_COLLECTION_PLACEHOLDER: 'CHILD_COLLECTION_PLACEHOLDER',
  STORY_CARD: 'STORY_CARD',
  STORY_CARD_V2: 'STORY_CARD_V2',
  STORY_CARD_PLACEMENT: 'STORY_CARD_PLACEMENT',
  COLORWAY: 'COLORWAY',
};

const CUSTOM_COLLECTION_ITEM_TYPES = {
  COLORWAY: 'COLORWAY',
  MASTER_PRODUCT: 'MASTER_PRODUCT',
  STORY_CARD: 'STORY_CARD',
  PLACEHOLDER: 'PLACEHOLDER',
  SUB_HEADER: 'SUB_HEADER',
};

const CUSTOM_COLLECTION_PRODUCT_APPEARANCES = {
  SHOW_MASTER_PRODUCTS: 'SHOW_MASTER_PRODUCTS',
  SHOW_COLORWAYS: 'SHOW_COLORWAYS',
};

const CUSTOM_COLLECTION_CARD_APPEARANCES = {
  '1_COLUMN': '1_COLUMN',
  '2_COLUMN': '2_COLUMN',
};

const CUSTOM_COLLECTION_MOBILE_LAYOUTS = {
  '1_COLUMN': '1_COLUMN',
  '2_COLUMN': '2_COLUMN',
};

const COLLECTION_N_COLUMNS = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
};

const COLLECTION_STORY_CARDS_TARGETING = {
  ALWAYS: 'Always Show',
  DYNAMIC_YIELD: 'DY Targeted',
};

const COLLECTION_STORY_CARDS_VISIBILITY = {
  DESKTOP: 'Desktop Web',
  HIDDEN: 'Hidden',
  MOBILE: 'Mobile Web',
};

export {
  COLLECTION_N_COLUMNS,
  COLLECTION_ITEM_TYPES,
  COLLECTION_STORY_CARDS_TARGETING,
  COLLECTION_STORY_CARDS_VISIBILITY,
  CUSTOM_COLLECTION_ITEM_TYPES,
  CUSTOM_COLLECTION_PRODUCT_APPEARANCES,
  CUSTOM_COLLECTION_CARD_APPEARANCES,
  CUSTOM_COLLECTION_MOBILE_LAYOUTS,
};
